import * as React from "react";
import { IconType } from "react-icons";
import { VscChevronDown } from "react-icons/vsc";

import { Button, ButtonColor, ButtonSize } from "../Button";
import "./ButtonWithOptions.scss";

interface ButtonWithOptionsOptions {
  title: string;
  color?: ButtonColor;
  isDisabled?: boolean;
  name?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

interface ButtonWithOptionsProps {
  name?: string;
  color?: ButtonColor;
  size?: ButtonSize;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isRound?: boolean;
  isLoading?: boolean;
  isOutlined?: boolean;
  icon?: IconType;
  rightIcon?: IconType;
  isDisabled?: boolean;
  isMenuDisabled?: boolean;
  isFullWidth?: boolean;
  buttonOptions: ButtonWithOptionsOptions[];
  children?: React.ReactNode;
}
interface ButtonWithOptionsState {
  isShowingMenu: boolean;
  renderMenuChildren: boolean;
}

export class ButtonWithOptions extends React.Component<ButtonWithOptionsProps, ButtonWithOptionsState> {
  hasMounted: boolean = false;
  wrapperRef = React.createRef<HTMLDivElement>();

  constructor(props: ButtonWithOptionsProps) {
    super(props);
    this.state = { isShowingMenu: false, renderMenuChildren: false };
    this.onClick = this.onClick.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount() {
    this.hasMounted = true;
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    this.hasMounted = false;
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  onClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (this.props.onClick && !this.props.isLoading) {
      this.props.onClick(event);
    } else {
      this.onMenuButtonClick();
    }
  }

  onMenuButtonClick() {
    if (this.props.isLoading) {
      return;
    }
    const isShowingMenu = !this.state.isShowingMenu;
    this.setState({ isShowingMenu: isShowingMenu, renderMenuChildren: true });

    if (!isShowingMenu) {
      setTimeout(() => {
        if (this.hasMounted) {
          this.setState({ renderMenuChildren: false });
        }
      }, 300);
    }
  }

  handleClickOutside(event: any) {
    if (this.state.isShowingMenu && this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
      this.onMenuButtonClick();
    }
  }

  render() {
    let className = "SCButtonWithOptions SCButton";

    let size = this.props.size;
    let color = this.props.color;

    if (this.props.size) {
      className += " " + size;
    }
    if (this.props.isRound) {
      className += " isRounded";
    }
    if (this.props.isOutlined) {
      className += " isOutlined";
    }
    if (this.props.isFullWidth) {
      className += " isFullwidth";
    }

    let leftIcon: any, rightIcon: any;

    if (this.props.icon) {
      leftIcon = <span className={"icon is-left"}>{this.props.icon as any}</span>;
    }

    if (this.props.rightIcon) {
      rightIcon = <span className={"icon is-right"}>{this.props.rightIcon as any}</span>;
    }

    let cheveronClassName = this.state.isShowingMenu ? className + " chevron isActive " : className + " chevron ";
    const wrapperClassName =
      this.state.isShowingMenu && !this.props.isLoading ? "ButtonWithOptions field has-addons isShowingMenu" : "ButtonWithOptions field has-addons";

    if (this.props.isLoading) {
      className += " is-loading";
    }

    const buttonOptions = this.state.renderMenuChildren
      ? this.props.buttonOptions.map((button) => {
          return (
            <Button
              size={size}
              key={button.title}
              color={button.color || color}
              name={button.name}
              disabled={button.isDisabled ? true : false}
              onClick={button.onClick}
            >
              {button.title}
            </Button>
          );
        })
      : null;

    return (
      <div ref={this.wrapperRef} className={wrapperClassName}>
        <div className="controlRow">
          <button className={className} onClick={this.onClick} disabled={this.props.isDisabled ? true : false}>
            {leftIcon}
            <span>{this.props.children}</span>
            {rightIcon}
          </button>

          <button className={cheveronClassName} onClick={this.onMenuButtonClick} disabled={this.props.isMenuDisabled ? true : false}>
            <VscChevronDown />
          </button>
        </div>

        <div className="treyWrapper">
          <div className="trey">{buttonOptions}</div>
        </div>
      </div>
    );
  }
}
